import { City } from "./../_models/city";
import { State } from "./../_models/state";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Courier } from "../_models/courier.js";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CityService {
  constructor(private http: HttpClient, public auth: AuthService) {}

  public getCities() {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.cities}/`;
    return this.http.get<City[]>(requestUrl, options);
  }

  public getCity(cityId: number) {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.cities}/${cityId}`;
    return this.http.get<City>(requestUrl, options);
  }

  public addCity(city: City): Observable<City> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.cities}/`;
    console.log(requestUrl);
    return this.http.post<City>(requestUrl, city, options);
  }

  public updateCity(city: City): Observable<City> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.cities}/${city.id}`;
    console.log(requestUrl);
    return this.http.put<City>(requestUrl, city, options);
  }

  public deleteCity(cityId: number) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.cities}/${cityId}`;
    console.log(requestUrl);
    return this.http.delete(requestUrl, options);
  }
}
